import { useEffect } from 'react';
import { estadoInstalacion, suscribirseInstalacion, estaCorriendoInstalada } from '../utils/installPrompt';
import { apiMarcarAppInstalada } from '../api';

/**
 * Avisa al backend cuando detecta que la app corre instalada (modo standalone, incluye
 * iOS home screen) o que el usuario acaba de completar la instalación en esta sesión.
 * El endpoint es idempotente — llamarlo de más no hace daño, el servidor solo escribe la
 * primera vez.
 */
export function useAppInstaladaSync(usuario) {
  useEffect(() => {
    if (!usuario) return;
    const avisar = () => { apiMarcarAppInstalada().catch(() => {}); };
    if (estaCorriendoInstalada()) avisar();
    return suscribirseInstalacion(() => {
      if (estadoInstalacion().instalado) avisar();
    });
  }, [usuario?.id]); // eslint-disable-line
}

export default useAppInstaladaSync;
